var Signal, magicInitialValue;

Signal = require('../signal');

magicInitialValue = {};

module.exports = function() {
  var previousValue, signal;
  signal = this;
  previousValue = magicInitialValue;
  return new Signal(function(send) {
    return signal.subscribe(function(val) {
      if (previousValue !== magicInitialValue) {
        send([previousValue, val]);
      }
      return previousValue = val;
    });
  });
};
